import * as is from 'utilities/is';
import { stripUnit } from 'utilities/formatting';
import {
    distance,
    interpolate,
    findNearestBounds
} from 'utilities/math';

export const animatable = Annotation => class extends Annotation {
    get styles() {
        const styles = { ...super.styles };

        if (shouldAnimate(this.animation)) {
            const { currentTime } = this.props,
                { frames, props } = this.animation;

            if (currentTime < 0) {
                return styles;
            }

            if (this.animation.interpolate) {
                const { lowerKey, upperKey } = findNearestBounds(currentTime, frames);

                if (!is.defined(lowerKey)) {
                    return styles;
                }

                if (!is.defined(upperKey)) {
                    return {
                        ...styles,
                        ...this.frameToStyles(frames[lowerKey], props)
                    };
                }

                const location = distance(lowerKey, upperKey, currentTime);

                props.forEach((p,i) => {
                    const start = stripUnit(frames[lowerKey][i]),
                        end = stripUnit(frames[upperKey][i]);

                    const interpolated = interpolate(start.value, end.value, location);
                    styles[p] = `${interpolated}${start.unit}`;
                });
            } else {
                const { lowerKey } = findNearestBounds(currentTime, frames);

                if (is.defined(lowerKey)) {
                    props.forEach((p,i) => styles[p] = frames[lowerKey][i]);
                }
            }
        }

        return styles;
    }

    frameToStyles(frame, styleNames) {
        return (
            styleNames.reduce((styles, name, i) => {
                styles[name] = frame[i];
                return styles;
            }, {})
        )
    }
}

function shouldAnimate(animation) {
    return (
        animation &&
        animation.props &&
        animation.frames &&
        !is.empty(animation.props) &&
        !is.empty(animation.frames)
    )
}